import { render } from "./CvdTabs.vue?vue&type=template&id=664d4476"
import script from "./CvdTabs.vue?vue&type=script&lang=js"
export * from "./CvdTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__